import {baseUrl} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

/**
 * Public (unauthenticated) venue self-signup request.
 * Posts the signup wizard fields to the public /venue/signup endpoint. No Auth0 token is used,
 * since this is called from the login page before any venue is authenticated.
 */
export const venueSignup = (
    signupData,
    successMethod,
    errorMethod
) => {
    const params = {
        venueName: signupData.venueName,
        contactName: signupData.contactName,
        contactPhone: signupData.contactPhone,
        contactPosition: signupData.contactPosition,
        contactEmail: signupData.contactEmail
    };

    fetch(baseUrl + uri + "/venue/signup", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        cache: "no-store",
        body: JSON.stringify(params)
    })
        .then((response) => {
            if (response.ok || response.status === 400) {
                return response.json();
            }
            errorMethod(true);
            return false;
        })
        .then((responseJson) => {
            responseJson && successMethod(responseJson);
            return true;
        })
        .catch(() => {
            errorMethod(true);
        });
};

/**
 * Public (unauthenticated) "Schedule a Demo / Contact Us" request from the marketing page.
 * Posts the contact form fields to the public /demo/request endpoint. No Auth0 token is used.
 */
export const scheduleDemo = (
    demoData,
    successMethod,
    errorMethod
) => {
    const params = {
        name: demoData.name,
        email: demoData.email,
        phone: demoData.phone,
        city: demoData.city,
        affiliatedClubs: demoData.affiliatedClubs,
        message: demoData.message
    };

    fetch(baseUrl + uri + "/demo/request", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        cache: "no-store",
        body: JSON.stringify(params)
    })
        .then((response) => {
            if (response.ok || response.status === 400) {
                return response.json();
            }
            errorMethod(true);
            return false;
        })
        .then((responseJson) => {
            responseJson && successMethod(responseJson);
            return true;
        })
        .catch(() => {
            errorMethod(true);
        });
};
